import { PDSProvider } from "@preownedfront/lib-reowds";
import { QueryClientProvider } from "@tanstack/react-query";
import { ZDSProvider } from "@zarafront/lib-zds";
import i18next from "i18next";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter as Router } from "react-router-dom";
import MainHeader from "src/components/Layout/MainHeader";
import { queryClient } from "src/utils/init/queryClient";
import "./assets/styles/styles.scss";
import { routes } from "./modules";
import { getCurrentBasePath } from "./utils/BasePathTools";
import { GrowthBookProvider } from "./utils/growthBook/growthbook";
import { ApplicationInitializerLoader } from "./utils/providers/ApplicationInitializerLoader";
import { ApplicationInitializerProvider } from "./utils/providers/ApplicationInitializerProvider";
import { NavigationHistoryProvider } from "./utils/providers/NavigationHistoryProvider";
import { ScriptsLoader } from "./utils/scripts/ScriptsLoader";
import { UpdateLanguage } from "./utils/updateLangue";
import { HelmetProvider } from "react-helmet-async";
import { MetaProvider } from "./utils/providers/MetaProvider";
import { AnalyticsProvider } from "./utils/providers/AnalyticsProviders";
import { i18nextInit } from "./utils/init/initialize";

i18nextInit();

ReactDOM.render(
  <HelmetProvider>
    <ZDSProvider
      dir="ltr"
      theme={{ mode: "light" }}
      toast={{
        notificationsAriaLabel: i18next.t("notifications_aria_label"),
        closeButtonAriaLabel: i18next.t("close_notification_aria_label"),
      }}
      carousel={{
        nextSlidesA11yButtonLabel: "View next items",
        prevSlidesA11yButtonLabel: "View previous items",
      }}
    >
      <PDSProvider dir="ltr" theme={{ mode: "light" }}>
        <Router basename={getCurrentBasePath()}>
          <MetaProvider>
            <QueryClientProvider client={queryClient}>
              <NavigationHistoryProvider>
                <I18nextProvider i18n={i18next}>
                  <ApplicationInitializerProvider>
                    <GrowthBookProvider>
                      <ScriptsLoader />
                      <AnalyticsProvider>
                        <MainHeader />
                        <main className="resell-theme" id="main-content">
                          <ApplicationInitializerLoader />
                          <UpdateLanguage />
                          {routes}
                        </main>
                      </AnalyticsProvider>
                    </GrowthBookProvider>
                  </ApplicationInitializerProvider>
                </I18nextProvider>
              </NavigationHistoryProvider>
            </QueryClientProvider>
          </MetaProvider>
        </Router>
      </PDSProvider>
    </ZDSProvider>
  </HelmetProvider>,
  document.getElementById("app") || document.createElement("div"),
);
